module.exports = __webpack_public_path__ + "img/Progress-Report-1.f739961b.png";